import React from 'react';
import TcsoDualFuelChecklistScreen from './TcsoDualFuelChecklistScreen';
import TcsoDualFuelMeterDetailsScreen from './TcsoDualFuelMeterDetailsScreen';
import {
  TcsoDualFuelContext,
  tcsoDualFuelInitialState,
  TcsoDualFuelInputs,
  TcsoDualFuelScreen,
  TcsoDualFuelScreenContext,
  TcsoDualFuelScreenInputs,
} from '../../context/TcsoDualFuelScreenContext';

export default function TcsoDualFuelScreenManager() {
  const [tcsoDualFuelScreenInputs, setTcsoDualFuelScreenInputs] = React.useState<TcsoDualFuelScreenInputs>({
    tcsoDualFuelScreen: TcsoDualFuelScreen.TCSO_DUAL_FUEL_CHECKLIST_SCREEN,
  });
  const [tcsoDualFuelInputs, setTcsoDualFuelInputs] = React.useState<TcsoDualFuelInputs>(tcsoDualFuelInitialState);

  function renderScreen() {
    switch (tcsoDualFuelScreenInputs.tcsoDualFuelScreen) {
      case TcsoDualFuelScreen.TCSO_DUAL_FUEL_CHECKLIST_SCREEN:
        return <TcsoDualFuelChecklistScreen />;
      case TcsoDualFuelScreen.TCSO_DUAL_FUEL_METER_DETAILS_SCREEN:
        return <TcsoDualFuelMeterDetailsScreen />;
      default:
        return <TcsoDualFuelChecklistScreen />;
    }
  }

  return (
    <TcsoDualFuelScreenContext.Provider value={{ tcsoDualFuelScreenInputs, setTcsoDualFuelScreenInputs }}>
      <TcsoDualFuelContext.Provider value={{ tcsoDualFuelInputs, setTcsoDualFuelInputs }}>
        {renderScreen()}
      </TcsoDualFuelContext.Provider>
    </TcsoDualFuelScreenContext.Provider>
  );
}
